import React from "react";
import { observer } from "mobx-react";
import UiMeet3dCompletedMeetingIndexPage from "~/modules/UiMeet3d/app/UiMeet3dCompletedMeetingIndexPage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
// Moving the styles of the LayoutWrapper here to avoid getting the wrong variables
import "../styles/TourLayout.less";

const PanelUiMeet3dCompletedMeetingIndexPage = observer(props => <UiMeet3dCompletedMeetingIndexPage {...props} />);

export default PanelUiMeet3dCompletedMeetingIndexPage;
